import React from "react";

const PageTitle = ({ children, title }) => (
  <div className="my-1 sm:my-4">
    <h2 className="text-gray-800 font-bold text-2xl flex flex-row items-center">
      {children ?? title}
    </h2>
  </div>
);

export default PageTitle;
